const MOBILE_REGEX = /Android.*Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|\bphone\b/i;
const TABLET_REGEX = /iPad|Android(?!.*Mobile)|Tablet/i;
export const getDevice = () => {
    if (typeof navigator === 'undefined') {
        return { type: undefined };
    }
    if ('userAgentData' in navigator) {
        const { mobile } = navigator.userAgentData;
        if (mobile) {
            return { type: 'mobile' };
        }
        return TABLET_REGEX.test(navigator.userAgent) ? { type: 'tablet' } : { type: undefined };
    }
    if (MOBILE_REGEX.test(navigator.userAgent)) {
        return { type: 'mobile' };
    }
    if (TABLET_REGEX.test(navigator.userAgent)) {
        return { type: 'tablet' };
    }
    return { type: undefined };
};
export const isMobileDevice = () => {
    const { type } = getDevice();
    return type === 'mobile' || type === 'tablet';
};
